import { createContext } from 'react';

type ChangeStrategyContextType = {
    clientId?: number;
    portfolioId?: number | string;
    personalDetails: Record<string, unknown>;
    layout: Record<string, unknown>;
    riskProfile: Record<string, unknown>;
    strategy: Record<string, unknown>;
    mainOwnerDetails?: Record<string, unknown>;
    productName?: string;
    jointAccountDetails?: Record<string, unknown> | null;
};

const initialContext: ChangeStrategyContextType = {
    clientId: undefined,
    portfolioId: undefined,
    personalDetails: {},
    layout: {},
    riskProfile: {},
    strategy: {},
};

const ChangeStrategyContext = createContext(initialContext);

export type { ChangeStrategyContextType };
export default ChangeStrategyContext;
